export default {
    contracts: [],
    sites: [],
    meterRounds: [],
    meterRoundDetails: {},
    meterRoundDownloadStatus: {},
    meterRoundProgress: null,
    ajaxCallsInProgress: 0
};